import React from 'react';
import Selector from './Selector';


function useDonationSelector(commands) {
  return ({
    eventHandlers: {

    },
  });
}

export default function DonationSelector(props) {
  const { sharedStates, commands } = props;
  const { eventHandlers } = useDonationSelector(commands);

  return (
    <div style={{
      display: 'flex', width: '100%', boxSizing: 'border-box', justifyContent: 'space-around', paddingInline: 20, marginBottom: 10,
    }}
    >
      <Selector
        sharedStates={{
          value: 0,
          text: '0,00',
          selected: sharedStates.donation === 0,
        }}
        commands={commands}
      />
      <Selector
        sharedStates={{
          value: 1,
          text: '1,00',
          selected: sharedStates.donation === 1,
        }}
        commands={commands}
      />
      <Selector
        sharedStates={{
          value: 2,
          text: '2,00',
          selected: sharedStates.donation === 2,
        }}
        commands={commands}
      />
      <Selector
        sharedStates={{
          value: 5,
          text: '5,00',
          selected: sharedStates.donation === 5,
        }}
        commands={commands}
      />
      <Selector
        sharedStates={{
          value: 10,
          text: '10,00',
          selected: sharedStates.donation === 10,
        }}
        commands={commands}
      />
    </div>
  );
}
